// * MUI Components
import { Box, Container, Typography, styled } from "@mui/material";
import { Security, Lock, Shield, VerifiedUser } from "@mui/icons-material";

// * Custom Styled Components
const CustomContainer = styled(Container)(({ theme }) => ({
  background: "linear-gradient(135deg, #3370FF 0%, #4318FF 100%)",
  minHeight: "400px",
  borderRadius: "15px",
  display: "flex",
  flexDirection: "column",
  justifyContent: "center",
  alignItems: "center",
  padding: theme.spacing(6),
  [theme.breakpoints.down("md")]: {
    minHeight: "auto",
    padding: theme.spacing(4),
  },
}));

const CustomBox = styled(Box)(({ theme }) => ({
  padding: theme.spacing(10, 0, 10, 0),
  margin: theme.spacing(0, 2, 0, 2),
  [theme.breakpoints.down("md")]: {
    padding: "0",
  },
}));

const SecurityItem = styled(Box)(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  gap: theme.spacing(2),
  marginBottom: theme.spacing(3),
  [theme.breakpoints.down("sm")]: {
    flexDirection: "column",
    textAlign: "center",
  },
}));

export default function Featured() {
  return (
    <CustomBox>
      <CustomContainer>
        <Box sx={{ textAlign: "center", mb: 4 }}>
          <Security sx={{ fontSize: 60, color: "white", mb: 2 }} />
          <Typography
            sx={{ fontSize: "35px", color: "white", fontWeight: "700", mb: 2 }}
          >
            Bank-Level Security
          </Typography>
          <Typography
            sx={{ fontSize: "16px", color: "#E6F0FF", fontWeight: "500", maxWidth: "600px", margin: "0 auto" }}
          >
            Your financial data is protected with the same technology used by Venmo, Chime, and thousands of other financial apps.
          </Typography>
        </Box>

        <Box sx={{ width: "100%", maxWidth: "700px" }}>
          <SecurityItem>
            <Box
              sx={{
                width: 60,
                height: 60,
                borderRadius: "50%",
                backgroundColor: "rgba(255, 255, 255, 0.2)",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                flexShrink: 0,
              }}
            >
              <Shield sx={{ fontSize: 30, color: "white" }} />
            </Box>
            <Box>
              <Typography sx={{ color: "white", fontWeight: "600", fontSize: "18px", mb: 0.5 }}>
                Powered by Plaid
              </Typography>
              <Typography sx={{ color: "#E6F0FF", fontSize: "14px" }}>
                Same technology used by Venmo & Chime
              </Typography>
            </Box>
          </SecurityItem>

          <SecurityItem>
            <Box
              sx={{
                width: 60,
                height: 60,
                borderRadius: "50%",
                backgroundColor: "rgba(255, 255, 255, 0.2)",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                flexShrink: 0,
              }}
            >
              <Lock sx={{ fontSize: 30, color: "white" }} />
            </Box>
            <Box>
              <Typography sx={{ color: "white", fontWeight: "600", fontSize: "18px", mb: 0.5 }}>
                We never see your credentials
              </Typography>
              <Typography sx={{ color: "#E6F0FF", fontSize: "14px" }}>
                Your login information stays secure with Plaid
              </Typography>
            </Box>
          </SecurityItem>

          <SecurityItem>
            <Box
              sx={{
                width: 60,
                height: 60,
                borderRadius: "50%",
                backgroundColor: "rgba(255, 255, 255, 0.2)",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                flexShrink: 0,
              }}
            >
              <VerifiedUser sx={{ fontSize: 30, color: "white" }} />
            </Box>
            <Box>
              <Typography sx={{ color: "white", fontWeight: "600", fontSize: "18px", mb: 0.5 }}>
                Data encrypted in transit and at rest
              </Typography>
              <Typography sx={{ color: "#E6F0FF", fontSize: "14px" }}>
                256-bit encryption protects all your data
              </Typography>
            </Box>
          </SecurityItem>
        </Box>
      </CustomContainer>
    </CustomBox>
  );
}
